module.exports = __webpack_public_path__ + "media/flags/flag-cr-098973ed.svg";